import React from "react";
import { Link } from "react-router-dom";

export default function CommercantsCTA() {
  return (
    <section className="py-12 sm:py-16">
      <div className="relative w-full overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#FFEAF5] via-[#FAD0E3] to-[#FFEAF5]" />
        <div className="absolute inset-x-0 top-0 h-16 sm:h-20 bg-gradient-to-b from-white to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-16 sm:h-20 bg-gradient-to-t from-white to-transparent" />

        <div className="relative max-w-[1519px] mx-auto px-4 sm:px-8 py-10 sm:py-14 lg:py-20 text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-asap font-semibold">
            Vous êtes commerçants à Claix ?
          </h2>
          <p className="mt-3 max-w-3xl mx-auto text-[13px] sm:text-[15px] text-neutral-700 leading-relaxed">
            Rejoignez le réseau PACTE et bénéficiez gratuitement de l'application pour promouvoir votre activité !
            <br/>Offres permanentes, offres ponctuelles et infos locales, voilà de quoi vous mettre en avant.
          </p>


          <div className="flex mt-12 items-center justify-center gap-4 sm:gap-6">
            <Link
              to="/contact?type=partenaire#form"
              className="inline-flex items-center justify-center rounded-full bg-black text-white
                             px-6 py-3 text-sm font-medium shadow-[0_10px_24px_rgba(0,0,0,0.35)]
                             hover:opacity-90 transition"
            >
              Rejoindre le réseau
            </Link>
            <Link
              to="/devenir-partenaire"
              className="inline-flex items-center justify-center rounded-full bg-white text-neutral-900
                            px-6 py-3 text-sm font-medium
                            s shadow-[0_4px_4px_rgba(0,0,0,0.25),_inset_0_0_10px_rgba(0,0,0,0.2)]
                            hover:bg-white/95 transition"
            >
              En savoir plus
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}